import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import md5 from 'js-md5';
import VueContextMenu from 'vue-contextmenu'
// import axios from "axios";
//
// axios.defaults.baseURL = '/api'
// const cors = require('cors')
const app = createApp(App)
app.use(VueContextMenu)
app.use(ElementPlus, {
    locale: zhCn,
})
app.provide('md5', md5);
app.use(ElementPlus)
app.use(store)
app.use(router)
// app.use(cors())
app.mount('#app')
